import './i18n';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import { LocalThemeProvider } from '@quizzach/contexts';
import React from 'react';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<HelmetProvider>
			<LocalThemeProvider>
				<App />
			</LocalThemeProvider>
		</HelmetProvider>
	</React.StrictMode>
);
